/**
 * RESPONSIBILITY: draw a band that is one box of words.
 *
 * The HTML was rendered when the band was saved (see @RenderOf), so nothing a client sent
 * reaches dangerouslySetInnerHTML.
 */
import { Html } from '@framework/react';
import { BandFrame } from './BandFrame';
import { BandButtons } from './BandButtons';
import type { BandDef, BandProps } from './kind';

function Draw({ b, tinted }: BandProps) {
  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      <Html className="md-body lede">{b.bodyHtml}</Html>
      <BandButtons b={b} />
    </BandFrame>
  );
}

export const text: BandDef = { has: (b) => !!b.bodyHtml, Draw };
